import type { WeChatPayAccountItem } from '@lighthouse/shared'

import { PLACEHOLDER_PASSWORD } from '../constants'
import type { WeChatPayAccountFormState } from './type'

/** The placeholder only represents a server-side value and must never be sent as a credential. */
export const buildWechatPaymentAccountUpdate = (params: WeChatPayAccountFormState): Partial<WeChatPayAccountItem> => ({
    displayName: params.displayName?.trim(),
    companyName: params.companyName?.trim(),
    enabled: params.enabled !== false,
    appId: params.appId,
    mchId: params.mchId.trim(),
    mode: params.mode,
    publicKey: params.publicKey === PLACEHOLDER_PASSWORD ? undefined : params.publicKey,
    publicKeyId: params.publicKeyId === PLACEHOLDER_PASSWORD ? undefined : params.publicKeyId,
    apiV3Key: params.apiV3Key === PLACEHOLDER_PASSWORD ? undefined : params.apiV3Key,
    mchPrivateKey: params.mchPrivateKey === PLACEHOLDER_PASSWORD ? undefined : params.mchPrivateKey,
    mchSerialNo: params.mchSerialNo === PLACEHOLDER_PASSWORD ? undefined : params.mchSerialNo,
    appSecret: params.appSecret === PLACEHOLDER_PASSWORD ? undefined : params.appSecret
})
